import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MA',
    name: 'Martín A.',
    location: 'Palermo, Buenos Aires',
    quote: 'Mi vieja cayó en una estafa de WhatsApp el año pasado y perdió $180.000. Compré el pack para toda la familia. En una tarde configuramos todo. Ahora duermo tranquilo.'
  }, {
    initials: 'SC',
    name: 'Silvina C.',
    location: 'Córdoba Capital',
    quote: 'Recibí un llamado de "el banco" que era perfectísimo, no lo podía creer. Por suerte ya había leído el Tomo 4 y supe exactamente cómo cortarles el juego. No perdí un solo peso.'
  }, {
    initials: 'JR',
    name: 'Javier R.',
    location: 'Rosario, Santa Fe',
    quote: 'Pensé que era exagerado pagar por esto. Dos semanas después me intentaron hackear el Home Banking. Las alertas que configuré con el Tomo 2 me avisaron al instante. El pack se pagó solo.'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-323">
      <div className="max-w-3xl w-full" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-325">
          <div className="text-brand-cyan text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-326">
            TESTIMONIOS
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-327">
            Personas que ya blindaron sus{' '}
            <span className="text-brand-cyan" data-id="element-328">cuentas</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-329">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="flex flex-col p-4 rounded-lg border border-brand-cyan/15 hover:border-brand-cyan/40 hover:shadow-[0_0_20px_rgba(0,212,255,0.06)] transition-all duration-300" style={{
          background: 'linear-gradient(135deg, #0d1333 0%, #0a0f2e 100%)'
        }} data-id="element-330">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-331">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-black font-bold text-[10px] shrink-0" style={{
              background: 'linear-gradient(135deg, #67e8f9 0%, #00D4FF 50%, #0891b2 100%)'
            }} data-id="element-332">
                  {testimonial.initials}
                </div>
                <div data-id="element-333">
                  <h4 className="text-white font-bold text-xs leading-tight" data-id="element-334">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-500 text-[10px]" data-id="element-335">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <div className="text-[10px] tracking-widest mb-2" data-id="element-336">⭐⭐⭐⭐⭐</div>
              <p className="text-gray-400 text-xs leading-relaxed italic" data-id="element-337">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}